import {px} from '@packages/systems/core/utils/WebflowCssSubset';
import View from '../View';

import {iconName, qualify} from '@packages/systems/wfdl-Qualified';
import {Plugins} from '@packages/systems/wfdl';
import {TListOfElement} from '@packages/systems/wfdl-ast';
import {createIntegratedAtom} from '@packages/utilities/integrated-types';

const config = createIntegratedAtom({
  displayName: 'Cart Item',
  icon: {
    type: 'Component',
    value: qualify(Plugins.name('Dynamo'), iconName('CollectionItem')),
  },
  showEmpty: true,
  constraints: {
    pinToParent: true,
    descendants: [
      {is: 'CommerceCartQuantity', rule: 'ExactlyOne'},
      {is: 'CommerceCartRemoveLink', rule: 'ExactlyOne'},
      {is: 'CommerceCartOptionList', rule: 'ExactlyOne'},
    ],
  },
  style: {
    base: {
      main: {
        noPseudo: {
          display: 'flex',
          paddingTop: px(12),
          paddingBottom: px(12),
          alignItems: 'flex-start',
        },
      },
    },
  },
  render: View,
  fields: {children: TListOfElement},
});

export default config;
